import { useGetOrderConfirmationQuery } from "@apis/orders/useOrders"
import { useNewOrderFunnel } from "../utils/useNewOrderFunnel"
import { OffersSummary } from "../OffersSummary"
import { useGetOfferQuery } from "@apis/offers/useOffers"
import type { IOffer } from "@commonTypes/offer"

type TConfirmationProps = {
  order_id_param?: number
}

export const Confirmation = ({ order_id_param }: TConfirmationProps) => {
  const { selectedOffer, order } = useNewOrderFunnel()
  const getOrderConfirmationQuery = useGetOrderConfirmationQuery(
    order_id_param ?? order?.order_id,
  )
  const getOfferQuery = useGetOfferQuery(
    getOrderConfirmationQuery.data?.offer_code,
  )

  return (
    <div className="tw:space-y-6">
      <OffersSummary
        data={[(selectedOffer as IOffer) ?? getOfferQuery.data]}
        title="Selected Offer"
        includeEnroll={false}
        isPending={getOfferQuery.isPending}
      />

      {getOrderConfirmationQuery.isPending ? (
        <p>Loading confirmation data....</p>
      ) : getOrderConfirmationQuery.isError ? (
        <p className="tw:text-destructive">Error loading order confirmation </p>
      ) : getOrderConfirmationQuery.data?.processed ? (
        <div className="tw:flex tw:flex-col tw:gap-2">
          <h1>Congratulations</h1>
          <div>
            <p>
              Confirmation Code:{" "}
              {getOrderConfirmationQuery.data?.confirmation_code}
            </p>
            <p>
              In a few days, you will receive a welcome kit that you have chosen
              to join the clean energy choice program with Inspire.
            </p>
            <p>
              If you have any questions, please call Inspire at (866) 403-2620.
            </p>
            <p>Thank you for choosing Inspire, have a nice day.</p>
            <hr />
            <p>Status: {getOrderConfirmationQuery.data?.order_status}</p>
            <p>Reason: {getOrderConfirmationQuery.data?.order_status_reason}</p>
          </div>
        </div>
      ) : (
        <div className="tw:flex tw:flex-col tw:gap-2">
          <h1 className="tw:text-destructive">
            There was a problem processing the order.
          </h1>
          {getOrderConfirmationQuery.data?.order_status.toUpperCase() ===
            "ERROR" && (
            <p className="tw:text-destructive">
              There was an issue submitting the customer’s order. The Operations
              team has been notified and will resolve it shortly. Please do not
              resubmit.
            </p>
          )}

          <div>
            <p>Status: {getOrderConfirmationQuery.data?.order_status}</p>
            <p>Reason: {getOrderConfirmationQuery.data?.order_status_reason}</p>
            <p>Details:</p>
            <ul>
              {getOrderConfirmationQuery.data?.error_messages.map(
                (error, index) => (
                  <li key={`${error}-${index}`}>{error as string}</li>
                ),
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}
